import { useQuery } from '@tanstack/react-query';

import {
  exportClaims,
  type IExportClaimsParams,
  type IExportClaimsResponse,
} from '@/services/admin';

export function useExportClaims(params: IExportClaimsParams, enabled: boolean) {
  const { data, isLoading, error } = useQuery<IExportClaimsResponse, Error>({
    queryKey: ['exportClaims', params],
    queryFn: ({ signal }) => exportClaims(params, signal),
    enabled,
  });

  return {
    data: data ?? null,
    loading: isLoading,
    error: error?.message ?? null,
  };
}
